export const formatEndpoint = (href: string) =>
  `*/${href.replace(/^(\/)|(\/)$/g, '')}`;
